import { BasicLoading } from '@agilize/components-core';
import { useFetch } from '@services/useFetch/useFetch';
import React from 'react';
import { Button } from './Helpdesk.styles';
import { HelpdeskProps } from './Helpdesk.types';

const Helpdesk = (props: HelpdeskProps) => {
  const { children } = props;

  const { doFetch, isFetching } = useFetch('zendesk/solicitation', 'get', {
    onSuccess: data => {
      window.open(data.url, '_blank');
    },
  });

  const openSolicitationWindow = async () => {
    doFetch();
  };

  return (
    <Button type="button" onClick={openSolicitationWindow} loading={isFetching}>
      <span>{children}</span>
      <div>
        <BasicLoading size={12} thickness={2} color="inherit" />
      </div>
    </Button>
  );
};

export default Helpdesk;
